<template>
  <div
    class="goal-content page-card-wrapper"
    :class="this.$store.state.locale.currentLocale === 'de' ? 'de-wrapper' : ''"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.skin_care_goal_title', {
          pad: $firstLetterCapitalize($store.state.locale.pad)
        })
      }}</span>
    </div>
    <div class="page-card-content skin-care-goal">
      <el-tabs v-model="activeTab" class="mt-10">
        <el-tab-pane
          :label="
            $t('text.time_in_diaper', {
              pad: $store.state.locale.pad
            }).toUpperCase()
          "
          name="dry"
        >
          <div class="mt-30 page-content">
            <div class="slider-text mb-30">
              {{ $t('text.day_goal').toUpperCase() }}
            </div>
            <div class="slider-wrapper h-100">
              <span
                v-if="dayValue"
                class="value-text slider-text"
                :style="{ left: dayValue / (this.max / 100) + '%' }"
                >{{ valueText(dayValue) }}</span
              >
              <el-slider
                v-model="dayValue"
                :min="0"
                :max="max"
                :step="0.5"
                :show-tooltip="false"
              >
              </el-slider>
              <div class="min-value slider-text">{{ $t('text.off') }}</div>
              <div class="max-value slider-text">{{ max }}h</div>
            </div>
            <div class="slider-text mb-30 mt-20">
              {{ $t('text.night_goal').toUpperCase() }}
            </div>
            <div class="slider-wrapper h-100">
              <span
                v-if="nightValue"
                class="value-text slider-text"
                :style="{ left: nightValue / (this.max / 100) + '%' }"
                >{{ valueText(nightValue) }}</span
              >
              <el-slider
                v-model="nightValue"
                :min="0"
                :max="max"
                :step="0.5"
                :show-tooltip="false"
              >
              </el-slider>
              <div class="min-value slider-text">{{ $t('text.off') }}</div>
              <div class="max-value slider-text">{{ max }}h</div>
            </div>
            <div class="text-right mt-10">
              <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
                $t('text.default').toUpperCase()
              }}</b-button>
              <el-button
                type="success"
                plain
                class="common-btn"
                :loading="saveLoading"
                @click="savePad()"
                :disabled="saveLoading"
                v-if="p('Patients.Goals.SkinCare.Add')"
                >{{ $t('text.save').toUpperCase() }}</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="
            $t('text.time_in_wet_pad', {
              pad: $store.state.locale.pad
            }).toUpperCase()
          "
          name="wet"
        >
          <div class="mt-30 page-content">
            <div class="slider-text mb-30">
              {{ $t('text.day_goal').toUpperCase() }}
            </div>
            <div class="slider-wrapper h-100">
              <span
                v-if="dayValue"
                class="value-text slider-text"
                :style="{ left: dayValue / (this.max / 100) + '%' }"
                >{{ valueText(dayValue) }}</span
              >
              <el-slider
                v-model="dayValue"
                :min="0"
                :max="max"
                :step="0.5"
                :show-tooltip="false"
              >
              </el-slider>
              <div class="min-value slider-text">{{ $t('text.off') }}</div>
              <div class="max-value slider-text">{{ max }}h</div>
            </div>
            <div class="slider-text mb-30 mt-20">
              {{ $t('text.night_goal').toUpperCase() }}
            </div>
            <div class="slider-wrapper h-100">
              <span
                v-if="nightValue"
                class="value-text slider-text"
                :style="{ left: nightValue / (this.max / 100) + '%' }"
                >{{ valueText(nightValue) }}</span
              >
              <el-slider
                v-model="nightValue"
                :min="0"
                :max="max"
                :step="0.5"
                :show-tooltip="false"
              >
              </el-slider>
              <div class="min-value slider-text">{{ $t('text.off') }}</div>
              <div class="max-value slider-text">{{ max }}h</div>
            </div>
            <div class="text-right mt-10">
              <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
                $t('text.default').toUpperCase()
              }}</b-button>
              <el-button
                type="success"
                plain
                class="common-btn"
                :loading="saveLoading"
                @click="savePad()"
                :disabled="saveLoading"
                v-if="p('Patients.Goals.SkinCare.Add')"
                >{{ $t('text.save').toUpperCase() }}</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="page-content" style="padding: 0 !important;">
        <div class="setting-wrapper mt-40 mb-30">
          <div class="image-wrapper inline-block">
            <img src="@/assets/image/light.svg" />
          </div>
          <div class="inline-block">
            <div class="first-row">
              <span class="left-side">
                <span class="inline-block label"
                  >{{
                    $t('text.average_time_in_pad', {
                      pad: $store.state.locale.pad
                    }) | firstLetterCapitalize
                  }}:</span
                >
                <span class="value">
                  <span v-if="patientData.AvgTimeinPad">
                    <span v-if="secondFormat(patientData.AvgTimeinPad)[0]"
                      >{{ secondFormat(patientData.AvgTimeinPad)[0] }}d
                    </span>
                    <span v-if="secondFormat(patientData.AvgTimeinPad)[1]">
                      {{ secondFormat(patientData.AvgTimeinPad)[1] }}h
                    </span>
                    <span v-if="secondFormat(patientData.AvgTimeinPad)[2]">
                      {{ secondFormat(patientData.AvgTimeinPad)[2] }}min
                    </span>
                  </span>
                  <span v-else>0min</span></span
                >
              </span>
              <span class="right-side">
                <span class="label inline-block"
                  >{{ $t('text.repositioning_24h') }}:</span
                >
                <span
                  >{{ patientData.Reposition }} {{ $t('text.per_day') }} ({{
                    $t('text.avg')
                  }})</span
                >
              </span>
            </div>
            <div class="second-row">
              <span class="left-side">
                <span class="inline-block label"
                  >{{
                    $t('text.average_time_in_position') | firstLetterCapitalize
                  }}:</span
                >
                <span class="value">
                  <span v-if="patientData.AgvTimeinPos">
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[0]"
                      >{{ secondFormat(patientData.AgvTimeinPos)[0] }}d
                    </span>
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[1]">
                      {{ secondFormat(patientData.AgvTimeinPos)[1] }}h
                    </span>
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[2]"
                      >{{ secondFormat(patientData.AgvTimeinPos)[2] }}min</span
                    >
                  </span>
                  <span v-else>0min</span></span
                >
              </span>
              <span class="right-side"
                >{{ $t('text.last_7_day_period') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      activeTab: 'dry',
      max: 16,
      patientData: {},
      padData: {
        dry: { day: 0, night: 0, loading: false },
        wet: { day: 0, night: 0, loading: false }
      }
    }
  },
  computed: {
    dayValue: {
      get() {
        return this.padData[this.activeTab].day
      },
      set(val) {
        this.padData[this.activeTab].day = val
      }
    },
    nightValue: {
      get() {
        return this.padData[this.activeTab].night
      },
      set(val) {
        this.padData[this.activeTab].night = val
      }
    },
    saveLoading() {
      return this.padData[this.activeTab].loading
    },
    secondFormat() {
      return function(num) {
        if (!num) return [0, 0, 0]
        let day = Math.floor(num / 86400)
        let hour = Math.floor((num - day * 86400) / 3600)
        let mimute = Math.floor((num - day * 86400 - hour * 3600) / 60)
        return [day, hour, mimute]
      }
    },
    valueText() {
      return value => {
        let num1 = Math.floor(value)
        let num2 = (value - num1) * 60
        if (num2) {
          if (num1) {
            return num1 + 'h' + ' ' + num2 + 'm'
          } else {
            return num2 + 'min'
          }
        }
        return num1 + 'h'
      }
    }
  },
  watch: {
    '$store.state.patient.selectedPatientGoal': function() {
      this.getInitVal()
    },
    '$store.state.patient.selectedPatientData': function() {
      this.getPatientData()
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
    this.getInitVal()
    this.getPatientData()
  },
  methods: {
    getInitVal() {
      let goal = this.$store.state.patient.selectedPatientGoal
      this.padData.dry.day = goal.MaxTimeInPadD ? goal.MaxTimeInPadD / 3600 : 0
      this.padData.dry.night = goal.MaxTimeInPadN
        ? goal.MaxTimeInPadN / 3600
        : 0
      this.padData.wet.day = goal.MaxTimeInYellowD
        ? goal.MaxTimeInYellowD / 3600
        : 0
      this.padData.wet.night = goal.MaxTimeinYellowN
        ? goal.MaxTimeinYellowN / 3600
        : 0
    },
    getPatientData() {
      this.patientData = this.$store.state.patient.selectedPatientData
    },
    savePad() {
      if (!this.$store.state.patient.selectedPatient) return false
      const isDry = this.activeTab === 'dry'
      const padData = this.padData[this.activeTab]

      let params = {
        patientId: this.$store.state.patient.selectedPatient.patientId
      }

      if (isDry) {
        params.MaxTimeInPadD = padData.day * 3600
        params.MaxTimeInPadN = padData.night * 3600
      } else {
        params.MaxTimeInYellowD = padData.day * 3600
        params.MaxTimeinYellowN = padData.night * 3600
      }

      padData.loading = true
      const apiMethod = isDry ? 'SaveSkinCareGoal' : 'SaveWetPadGoal'

      ApiService[apiMethod](params)
        .then(response => {
          padData.loading = false
          if (response.data.success) {
            this.$store.dispatch('patient/getSelectedPatientGoal')
            this.$store.dispatch('patient/getSelectedPatientHistoryData')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          padData.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.de-wrapper {
  .left-side {
    margin-right: 20px !important;
    .label {
      width: 250px;
    }
  }
  .right-side {
    .label {
      width: 130px;
    }
  }
}
</style>
